<template>
  <el-dialog
    class="gp-dialog"
    :title="title"
    :visible="true"
    :close-on-click-modal="true"
    :before-close="beforeClose"
    v-loading="loading"
    :element-loading-text="$t('数据加载中')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :width="width"
    :top="marginTop"
  >
    <div :style="{ height }" style="overflow: auto" class="gp-dialog-content">
      <v-chart
        style="height: 100%; width: 100%"
        v-for="(item, index) in list"
        :key="index"
        :options="item"
        :autoresize="true"
      />
    </div>
  </el-dialog>
</template>

<script>
import { awaitTo } from '@/utils/utils';
import { getRamanTestResultSpectrum } from '@/api/raman-query';
import { isEmpty } from '@/utils/is';
import { makeAreaStyleLine } from '@/echartOption/common';

export default {
  props: {
    title: String,
    type: Number,
    row: Object,
    container: Object,
    width: String,
    height: String,
    marginTop: String,
    appendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      list: [],
      loading: false
    };
  },
  methods: {
    async getData() {
      const { accumulateCount, deviceSn, collectCount, testCode } = this.row;

      this.loading = true;

      const [err, res] = await awaitTo(
        getRamanTestResultSpectrum({
          deviceSn,
          testCode,
          collectCount,
          accumulateCount
        })
      );

      if (err || isEmpty(res?.data)) {
        this.loading = false;
        return;
      }

      const data = this.parseData(res.data);

      data.forEach((e, i) => {
        this.list.push(
          makeAreaStyleLine({
            title: ['偏移光谱', '背景光谱', '原始光谱'][i],
            datas: e
          })
        );
      });

      this.loading = false;
    },
    parseData(data) {
      const keys = ['xData', 'xData_bj', 'xData_or'];

      const axis = keys.map(key => {
        const item = data[key];

        delete data[key];

        return [item];
      });

      Object.keys(data).forEach(key => {
        if (key === 'yData') {
          if (isEmpty(axis[0][1])) axis[0][1] = [];
          axis[0][1].push(data[key]);
        } else if (key.indexOf('bj') !== -1) {
          if (isEmpty(axis[1][1])) axis[1][1] = [];
          axis[1][1].push(data[key]);
        } else if (key.indexOf('or') !== -1) {
          if (isEmpty(axis[2][1])) axis[2][1] = [];
          axis[2][1].push(data[key]);
        }
      });

      return axis;
    },
    beforeClose(done) {
      this.$destroy();
      typeof done === 'function' && done();
    }
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    } else {
      this.container.appendChild(this.$el);
    }

    this.getData();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss" scoped>
.gp-dialog {
  &-content {
    @include scrollar-style-bold;
  }
}
</style>
